import React, { Fragment } from "react";
import ApartmentButton from "../../component/ApartmentButton";
import YellowConfirm from "../../component/YellowConfirm";
import Button from "../../component/Button";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { connect } from "react-redux";
import {
  getAllApartments,
  hideNotification,
  getSingleApartment,
  removeUserFromApartment,
} from "../../reducers/apartments";
import { getAllServices } from "../../reducers/services";
import { logout, login } from "../../reducers/account";

const textAllert = [
  {
    text: "Attenzione",
    fontSize: 32,
    paddingBottom: "3vh",
  },
  {
    text:
      "La seguente operazione non potrà essere annullata. Procedere con l’archiviazione di Bilancio e Chat ed eliminare i dati presenti su questo appartamento?",
    fontSize: 18,
  },
  {
    text: "Confermi?",
    fontSize: 18,
    paddingBottom: "3vh",
  },
];

class Apartment extends React.Component {
  state = {
    openStampa1: false,
    openStampa2: false,
    inProp: false,
    show: null,
  };

  componentDidMount() {
    if (!this.props.user) {
      this.props.login();
    }
    this.props.getAllServices();
    this.props.getSingleApartment(this.props.match.params.id);
  }

  setMenu = (menu) => {
    if (this.state.show == menu) {
      this.setState({ show: null });
    } else {
      const time = new Date();
      this.setState({ show: menu });
      localStorage.setItem(
        this.props.apartment.name + menu,
        time.toISOString()
      );
    }
  };

  goBack = () => {
    this.props.history.push("/Home");
  };

  logout = () => {
    this.props.history.push("/");
  };

  confirm = () => {
    this.setState({ openStampa2: !this.state.openStampa2 });
    this.setState({ openStampa1: !this.state.openStampa1 });
    setTimeout(() => {
      this.setState({ openStampa2: !this.state.openStampa2 });
    }, 1200);
  };

  showNotification = () => {
    const { apartment } = this.props;
    if (apartment) {
      // const localStorageKeyName = apartment.name + "Chat";
      const localStorageKeyName = apartment.name + "chat";
      const localStorageKey = localStorage.getItem(localStorageKeyName);

      // console.log(localStorageKey)
      if (localStorageKey) {
        return apartment.user.messaggi
          .filter(
            (messaggi) =>
              new Date(localStorageKey) - new Date(messaggi.createdAt) < 0
          )
          .filter((messaggi) => messaggi.from === "user").length;
      } else return 0;
    }
    return 0;
  };

  showWarning = (apartmentButton) => {
    const { apartment, services } = this.props;

    if (apartment && services.length > 0) {
      const localStorageKeyName = apartment.name + apartmentButton;
      const localStorageKey = localStorage.getItem(localStorageKeyName);

      if (localStorageKey) {
        return apartment.user.servizi
          .filter(
            (ser) =>
              ser.tipologia.toLowerCase() === apartmentButton.toLowerCase()
          )
          .filter(
            (ser) => new Date(localStorageKey) - new Date(ser.createdAt) < 0
          ).length;
      } else {
        localStorage.setItem(localStorageKeyName, new Date().toISOString());
        return 0;
      }
    }
    return 0;
  };

  archiveResidente = () => {
    this.props.removeUserFromApartment();
    this.setState({ openStampa1: !this.state.openStampa1 });
  };

  render() {
    // console.log(this.state);
    // console.log(this.props.services);
    // console.log(this.props.apartment);
    return (
      <Fragment>
        <div
          style={{
            height: window.innerHeight,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              width: "100%",
              paddingTop: "4vh",
              paddingBottom: "4vh",
            }}
          >
            <Button {...this.props} scope={"back"} goTo={this.goBack} />
            <div
              style={{
                width: "76vw",
                height: "6vh",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#FFE533",
              }}
            >
              {this.props.apartment.name}
            </div>
            <Button {...this.props} scope={"logOut"} goTo={this.logout} />
          </div>
          <div style={{ display: "flex" }}>
            {this.props.services.map((sectionButton) => {
              const warning = this.showWarning(sectionButton.target);
              const notification = this.showNotification();
              return (
                <ApartmentButton
                  key={`apt_button_${sectionButton.target}_${this.props.apartment.name}`}
                  backgroundColor={"#FFEF85"}
                  show={this.state.show}
                  {...this.props}
                  // buttonName={sectionButton.name.toLowerCase()}
                  buttonName={sectionButton.target}
                  serviceId={sectionButton.target}
                  size={20}
                  // warningButton={this.showWarning(sectionButton.name)}
                  warningButton={warning}
                  notificationButton={notification}
                  setMenu={this.setMenu}
                  servizi={this.props.apartment.user.servizi.filter(
                    (servizi) =>
                      servizi.tipologia.toLowerCase() ==
                      (this.state.show && this.state.show.toLowerCase())
                    // servizi.tipologia == this.state.show
                  )}
                  messaggi={this.props.apartment.user.messaggi}
                  versamenti={this.props.apartment.user.versameti}
                  apartmentData={this.props.apartment.user}
                  apartmentName={this.props.apartment.name}
                  numberOfButtons={this.props.services.length}
                />
              );
            })}
          </div>
        </div>
        {this.state.show == null && (
          <div
            style={{
              position: "absolute",
              top: "56vh",
              width: window.innerWidth,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <YellowConfirm
              text={"Archivia Residente"}
              width={"8vw"}
              padding={"1.5vh"}
              action={() =>
                this.setState({ openStampa1: !this.state.openStampa1 })
              }
            />
          </div>
        )}
        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={Math.random()}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openStampa1 ? (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  // zIndex: 600,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={this.archiveResidente}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: "40vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    // zIndex: 600,
                  }}
                >
                  {textAllert.map((textAllert) => (
                    <div
                      style={{
                        fontSize: textAllert.fontSize,
                        paddingBottom: textAllert.paddingBottom,
                        paddingLeft: "4vw",
                        paddingRight: "4vw",
                      }}
                    >
                      {textAllert.text}
                    </div>
                  ))}
                  <YellowConfirm
                    text={"Conferma"}
                    action={this.confirm}
                    padding={"1.5vh"}
                    width={"8vw"}
                  />
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={Math.random()}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openStampa2 ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() =>
                  this.setState({ openStampa1: !this.state.openStampa1 })
                }
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: "40vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 200,
                  }}
                >
                  <div style={{ color: "#645B40", fontSize: 36 }}>
                    Operazione Completata
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  apartments: state.apartments.data,
  apartment: state.apartments.singleApartment,
  services: [
    ...(state.account.data.user &&
    state.account.data.user.role.type === "usergestionale"
      ? []
      : extraServices),
    ...state.services.data,
  ],
  loading: state.apartments.loading,
  error: state.apartments.error,
});

export default connect(mapStateToProps, {
  getAllApartments,
  hideNotification,
  getSingleApartment,
  getAllServices,
  login,
  removeUserFromApartment,
})(Apartment);

const extraServices = [
  {
    name: "Bilancio",
    target: "bilancio",
  },
  {
    name: "Chat",
    target: "chat",
  },
];
